import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';

export const propertyStyles = stylex.create({
  disabledAction: { opacity: 0.44, pointerEvents: 'none', cursor: 'inherit' },
  panel: {
    backgroundColor: colors.panelBackground,
    color: colors.bodyText,
    borderWidth: 0,
    margin: 0,
    borderRadius: '6px',
  },
  compactPanelBody: { padding: '5px' },
  panelBody: { flex: '1 1 auto', minHeight: '1px', padding: '20px' },
  panelHeading: {
    fontSize: 'var(--font-size-xxxlg)',
    color: colors.legacyToolsPrimary,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headingIcon: { paddingRight: '10px' },
  propertyRow: { display: 'flex', flexDirection: 'row', marginBottom: '0.625rem' },
  itemNameLabel: { marginBottom: 0, paddingRight: '0.3125rem', whiteSpace: 'nowrap' },
  itemName: { flex: '1 1 auto', overflow: 'hidden', overflowWrap: 'break-word', wordBreak: 'break-word' },
  acl: { backgroundColor: colors.tableRowAlternate, paddingBottom: '0.3125rem', paddingLeft: '0.1875rem' },
  advanced: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.toolsDisabledBorder,
    borderRadius: '6px',
    marginBottom: '0.625rem',
    paddingRight: '0.25rem',
    paddingLeft: '0.25rem',
  },
  advancedList: { width: '100%', marginBottom: 0 },
  advancedPropertyValue: { width: '100%' },
  cacheActions: {
    flex: '1 1 auto',
    overflow: 'hidden',
    marginTop: '0.3125rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cacheButton: { margin: '0.25rem' },
  cacheHelp: { marginLeft: '0.25rem', color: colors.monitorOverlayText },
  footer: { display: 'flex', flexDirection: 'row', flex: 'none' },
  archiveAction: { marginTop: '0.3125rem', marginRight: '0.3125rem' },
  footerActions: {
    flex: '1 1 auto',
    overflow: 'hidden',
    marginTop: '0.3125rem',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.375rem',
  },
  duplicateMenu: { display: 'flex', flexDirection: 'column', gap: '0.25rem', padding: '0.5rem' },
  duplicateAction: {
    cursor: 'pointer',
    paddingLeft: '20px',
    paddingRight: '20px',
    width: '100%',
    fontSize: '0.875rem',
    borderWidth: 0,
    textAlign: 'left',
    backgroundColor: {
      'default': null,
      ':focus-visible': 'transparent',
      ':focus': 'transparent',
      ':active': 'transparent',
      ':hover': colors.surfaceSubtle,
    },
    outlineStyle: { 'default': null, ':focus-visible': 'none', ':focus': 'none', ':active': 'none' },
  },
  section: { marginBottom: '0.625rem' },
  scopeSection: { display: 'flex', flexDirection: 'column', marginBottom: '0.3125rem' },
  scopeHeading: { display: 'flex', flexDirection: 'row', flex: '1 1 auto', overflow: 'hidden' },
  fieldLabel: { marginBottom: 0 },
  helpLink: { marginLeft: '5px' },
  interactiveIcon: {
    color: {
      'default': colors.legacyToolsLink,
      ':hover': colors.legacyToolsPrimary,
      ':focus': colors.legacyToolsPrimary,
      ':active': colors.legacyToolsPrimary,
    },
  },
  scopeValue: { display: 'flex', flexDirection: 'row', marginTop: 0, marginBottom: 0, marginLeft: '0.3125rem' },
  sourceScope: { marginLeft: '0.3125rem', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' },
  scopeAction: {
    marginLeft: '0.3125rem',
    color: colors.legacyToolsPrimary,
    cursor: 'pointer',
    textDecoration: { 'default': null, ':hover': 'underline' },
  },
  globalScope: { fontStyle: 'italic' },
  hoverLink: { textDecoration: { 'default': null, ':hover': 'underline' } },
  usageSection: { display: 'flex', flexDirection: 'column' },
  usageLabel: { marginBottom: 0, paddingTop: '0.1875rem', paddingLeft: '0.1875rem' },
  usageContent: { paddingBottom: '0.3125rem', paddingLeft: '0.625rem' },
  usageIcon: {
    marginLeft: '5px',
    marginRight: '2px',
    color: {
      'default': colors.legacyToolsLink,
      ':hover': colors.legacyToolsPrimary,
      ':focus': colors.legacyToolsPrimary,
      ':active': colors.legacyToolsPrimary,
    },
  },
  actionLink: {
    color: colors.legacyToolsPrimary,
    cursor: 'pointer',
    textDecoration: { 'default': null, ':hover': 'underline' },
  },
  notificationLink: { marginBottom: '5px', textDecoration: { 'default': null, ':hover': 'underline' } },
  notificationList: { display: 'flex', flexDirection: 'column', marginTop: 0, marginBottom: 0 },
  addIcon: { paddingRight: '5px' },
  notificationSettings: { marginTop: '0.625rem' },
  scopeModal: { textAlign: 'center' },
  scopeWarning: { color: colors.warning, fontWeight: 'bolder' },
  scopeToggle: {
    fontSize: 'larger',
    color: {
      'default': colors.legacyToolsLink,
      ':hover': colors.legacyToolsPrimary,
      ':focus': colors.legacyToolsPrimary,
      ':active': colors.legacyToolsPrimary,
    },
    marginTop: '0.625rem',
    marginBottom: '0.625rem',
  },
  itemSelector: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '0.625rem',
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectorLabel: { paddingRight: '0.3125rem', whiteSpace: 'nowrap' },
  itemSelectorControl: { flex: '1 1 auto', overflow: 'hidden' },
  panelTitle: { flex: '1 1 auto', overflow: 'hidden' },
  restoreLink: { textDecoration: 'none', cursor: 'pointer' },
  danger: { color: colors.borderInvalid },
  versionLoading: { display: 'flex', justifyContent: 'center', paddingTop: '1rem', paddingBottom: '1rem' },
  versionList: { display: 'flex', flexDirection: 'column' },
  versionWarning: { marginBottom: '0.75rem' },
  descriptionLabel: { marginBottom: 0 },
  descriptionInput: { minHeight: '18px' },
  descriptionText: { marginBottom: '0.3125rem', whiteSpace: 'pre-wrap' },
  propertyName: { paddingTop: '0.1875rem', paddingRight: '0.1875rem', paddingBottom: 0, paddingLeft: '0.1875rem' },
  propertyValue: {
    paddingTop: 0,
    paddingRight: '0.1875rem',
    paddingBottom: '0.1875rem',
    paddingLeft: '0.625rem',
    marginBottom: '0.3125rem',
  },
  alternateProperty: { backgroundColor: colors.tableRowAlternate },
  validationHelp: { marginTop: '0.3125rem' },
  validationDetails: { marginBottom: 0, paddingLeft: '1.25rem' },
  propertyText: {
    wordBreak: 'break-all',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    maxHeight: '200px',
    overflow: 'auto',
  },
  propertyDetails: { overflowWrap: 'break-word', marginTop: '0.3125rem', maxHeight: '200px', overflow: 'auto' },
  overrideLink: {
    cursor: 'pointer',
    color: colors.legacyToolsLink,
    textDecoration: 'underline',
    paddingLeft: '0.1875rem',
  },
  removeOverride: { padding: '0.25rem', cursor: 'pointer', borderRadius: '0.25rem' },
  copyIcon: { marginLeft: '2px' },
  copyContainer: { display: 'inline-block', paddingLeft: '3px' },
  loadingOverride: { marginLeft: '5px' },
  compactButton: { height: '30px' },
  compactPropertyInput: { padding: '0.3125rem' },
  propertyInput: { width: '100%', height: '30px', fontSize: 'var(--font-size-sm)' },
});
